import React, { useEffect } from "react";

import { Grid } from "@mui/material";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CommercialInvoice } from "../../../../../util/enums";
import Checkbox from "../../../../Form/Checkbox";
import Input from "../../../../Form/Input";
import Skeleton from "../../../../Generic/Skeleton";
import { useBookingResources } from "../../../context/AvailableOrders";
import useStyles from "../styles";
import { CommercialInvoiceFormProps } from "../types";

export const CommercialInvoiceExporterInformation = ({
  commercialInvoice,
  viewOnly,
  fieldHasError,
  getErrorByField,
  updateComercialInvoice,
  loadingBooking = true,
}: CommercialInvoiceFormProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { isExporterInfoDifferentFromVendor, setIsExporterInfoDifferentFromVendor } =
    useBookingResources();

  useEffect(() => {
    if (commercialInvoice?.exporterName) {
      setIsExporterInfoDifferentFromVendor(true);
    }
  }, [commercialInvoice?.exporterName]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Divider orientation={"horizontal"} flexItem className={classes.dividerHorizontal} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.title}>
        <span>{translate("exporter")}</span>
      </Grid>
      <Grid item xs={12}>
        <Skeleton isLoading={loadingBooking}>
          <Checkbox
            disabled={viewOnly}
            label={translate("ExporterInformationIsDifferentFromTheVendor")}
            checked={isExporterInfoDifferentFromVendor}
            onChange={(_, checked) => setIsExporterInfoDifferentFromVendor(checked)}
          />
        </Skeleton>
      </Grid>
      {isExporterInfoDifferentFromVendor && (
        <Grid container item spacing={2}>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Skeleton isLoading={loadingBooking}>
              <Input
                required
                data-cy={CommercialInvoice.EXPORTER_NAME}
                name={CommercialInvoice.EXPORTER_NAME}
                value={commercialInvoice?.exporterName || ""}
                label={translate(CommercialInvoice.EXPORTER_NAME)}
                onChange={(event) =>
                  updateComercialInvoice(CommercialInvoice.EXPORTER_NAME, event.target.value)
                }
                error={fieldHasError(CommercialInvoice.EXPORTER_NAME)}
                errorMessage={getErrorByField(CommercialInvoice.EXPORTER_NAME)}
                disabled={viewOnly}
                placeholder={translate(CommercialInvoice.EXPORTER_NAME)}
              />
            </Skeleton>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Skeleton isLoading={loadingBooking}>
              <Input
                required
                data-cy={CommercialInvoice.EXPORTER_CONTACT_DETAILS}
                name={CommercialInvoice.EXPORTER_CONTACT_DETAILS}
                value={commercialInvoice?.exporterContactDetails || ""}
                label={translate(CommercialInvoice.EXPORTER_CONTACT_DETAILS)}
                onChange={(event) =>
                  updateComercialInvoice(
                    CommercialInvoice.EXPORTER_CONTACT_DETAILS,
                    event.target.value
                  )
                }
                error={fieldHasError(CommercialInvoice.EXPORTER_CONTACT_DETAILS)}
                errorMessage={getErrorByField(CommercialInvoice.EXPORTER_CONTACT_DETAILS)}
                disabled={viewOnly}
                placeholder={translate(CommercialInvoice.EXPORTER_CONTACT_DETAILS)}
              />
            </Skeleton>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
